<div class="mat-calendar-footer">
  @for (range of ranges ; track range; let i = $index) {
    <button mat-raised-button [class.isActiveDate]="activeDate == range.key"
    (click)="setRange(range.key)">{{range.label}}</button>
  }
</div>